import { SortState } from "store/filters";
import { ActionType, createStandardAction, getType } from "typesafe-actions";
import { useTypesafeActions } from "store";
import { TenantType } from "generated/graphql.schema";

export type TenantsControlState = {
  sort: SortState;
  from: number;
  accountsChanged: boolean;
  selected: string[];
  previousNamePrefix: string | undefined;
  namePrefix: string | undefined;
  accountTypeFilter: TenantType | "";
  blackList: string[];
};

export const initialState: TenantsControlState = {
  sort: { field: "name", direction: "ASC" },
  from: 0,
  accountsChanged: false,
  selected: [],
  previousNamePrefix: undefined,
  namePrefix: undefined,
  accountTypeFilter: "",
  blackList: []
};

export const TenantsControlActions = {
  updateSort: createStandardAction("UpdateSort")<SortState>(),
  updateFrom: createStandardAction("UpdateFrom")<number>(),
  incrementFrom: createStandardAction("IncrementFrom")<number>(),
  updateAccountsChanged: createStandardAction("UpdateAccountsChanged")<
    boolean
  >(),
  updateSelected: createStandardAction("UpdateSelected")<string[]>(),
  updatePreviousNamePrefix: createStandardAction("UpdatePreviousNamePrefix")<
    string | undefined
  >(),
  addToBlackList: createStandardAction("AddToBlackList")<string[]>(),
  removeFromBlackList: createStandardAction("RemoveFromBlackList")<string[]>(),
  updateNamePrefix: createStandardAction("UpdateNamePrefix")<
    string | undefined
  >(),
  setAccountTypeFilter: createStandardAction("SetAccountTypeFilter")<
    TenantType | ""
  >()
};

export type TenantsControlActionTypes = typeof TenantsControlActions;

export function reducer(
  state: TenantsControlState,
  a: ActionType<TenantsControlActionTypes>
): TenantsControlState {
  switch (a.type) {
    case getType(TenantsControlActions.updateSort):
      return {
        ...state,
        sort: a.payload,
        from: 0
      };
    case getType(TenantsControlActions.updateFrom):
      return {
        ...state,
        from: a.payload
      };
    case getType(TenantsControlActions.incrementFrom):
      return {
        ...state,
        from: state.from + a.payload
      };
    case getType(TenantsControlActions.updateAccountsChanged):
      return {
        ...state,
        accountsChanged: a.payload
      };
    case getType(TenantsControlActions.updateSelected):
      return {
        ...state,
        selected: a.payload
      };
    case getType(TenantsControlActions.updatePreviousNamePrefix):
      return {
        ...state,
        previousNamePrefix: a.payload,
        from: 0,
        selected: []
      };
    case getType(TenantsControlActions.updateNamePrefix):
      return {
        ...state,
        namePrefix: a.payload
      };
    case getType(TenantsControlActions.setAccountTypeFilter):
      return {
        ...state,
        accountTypeFilter: a.payload,
        from: 0,
        selected: []
      };
    case getType(TenantsControlActions.addToBlackList):
      return {
        ...state,
        blackList: state.blackList.concat(a.payload)
      };
    case getType(TenantsControlActions.removeFromBlackList):
      return {
        ...state,
        blackList: state.blackList.filter(item => !a.payload.includes(item))
      };
  }
}

export function useTenantsControlState() {
  return useTypesafeActions<TenantsControlState, TenantsControlActionTypes>(
    reducer,
    initialState,
    TenantsControlActions
  );
}
